module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/pages/pricing-0dfb5c50379a2934e015f66c7009d4c5.jpg";